
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Summer Camp</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Summer <span> Camp 2022 </span></h2>
		</div>
		<div class="row text-justify">

			<div class="col-md-8">
				<p>
					We all have gone through a tough patch in last two years, so did the kids. Social Skills Development
					like Leadership, Communication and Participation were far away in that patch. Sumer Camp 2022 is an
					initiative to get the kids back to action. With this summer camp they not only have the experience
					of different activities but also will learn Self-Respect and Character Building including
					Responsibility, Resourcefulness and Resilience.
				</p>
				<p>In today’s era Community Living/Service Skills are most required ones for the kids to understand and
					cope with the coming hassle bustle schedules. Whereas, this camp will help kids to understand
					Caring, Fairness, Trustworthiness and many other skills.</p>
				<p>By participating in summer camps kids usually learn to overcome stress, strain, anxiety, fear,
					inferiority, cowardice, stage fear, irregular eating habits, and time management and grow to a
					brighter individual.</p>

			</div>
			<div class="col-md-4">
				<div class="image-effect-2">
					<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/summer-camp.jpg" alt="GHRSCF"
						class="w-100">
				</div>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-md-6">
				<p><b>
						Dates – 4<sup>th</sup> May 2022 to 10<sup>th</sup> June 2022
					</b></p>
				<p><b>Venue: Sharddha Park Hingana, Nagpur</b></p>
				<p><b>Fees – Rs. 500 /- (Refundable after successful Completion of the Camp)</b></p>
				<p><b>Age Group – 10 years to 16 Years</b></p>
				<p><b>Batch Size – 30 Participants </b></p>
			</div>
			<div class="col-md-6">
				<div class="widget_title inner-title">
					<h4 class="fw-bold">Participants should bring the Following</h4>
				</div>
				<ul class="list-style list-style1">
					<li>Sport shoes / Canvas shoes</li>
					<li>Long Note Books/ colours /crayonss</li>
					<li>Water Bottles</li>
					<li>Mask and Sanitizer </li>
					<li>Snacks </li>
				</ul>
			</div>
		</div>
		<div class="row mt-5">
			<div class="widget_title inner-title">
				<h4 class="fw-bold">Important Instructions:</h4>
			</div>
			<div class="col-md-12">
				<ul class="list-style list-style1">
					<li> Jewellery (Gold, Silver (or) imitation), Money with participant is strictly not allowed.</li>
					<li> Admission into the Camp is considered only after payment of entire FEE</li>
					<li> The application forms duly filled in must be submitted along with 2 pass post size photographs
					</li>
					<li> Interested students can carry cameras and mobile phones at their own responsibility and Risk.
					</li>
					<li> Participants should strictly follow the instructions of the management staff and trainers.</li>
					<li> Only parents or guardians should pick and drop the kid to the camp and register their
						attendance daily at the counter by showing ID</li>
					<li> Cancellation of admission is entirely at the discretion of Parents / Guardian.</li>
					<li> Fee is non-refundable In case of cancellation.</li>

					<li><span>To claim refund of Rs. 500, minimum 80% attendance of the paticipants is a must.</span>
					</li>
					<li> The Camp organisers are not responsible for any kind of snacks or refreshment arrangements
					</li>
					<li> Organisers have all the rights to make necessary changes in time table in case if required or
						in emergency </li>
				</ul>
				<h6><b>Note: Parents please check that your kid follows all instructions given above.</b></h6>
			</div>

		</div>
	</div>
</section>
